import { differenceInDays } from 'date-fns';
import {
  MIGRATION_DAY_WINDOW,
  V4_AUTO_MIGRATION_IN_FLOW_STATUSES,
} from './constants';

/**
 * `recentUpMigrationStartedAt` can still be null while these GraphQL statuses
 * are set. Treating them as migrating keeps users on the migration gate
 * instead of redirecting to V3 (e.g. from HandleIncompatibleAccountThatSuspends).
 */
const MIGRATION_GRAPHQL_STATUSES_INDICATING_ACTIVE_GATE = new Set<string>([
  ...V4_AUTO_MIGRATION_IN_FLOW_STATUSES,
  'FioVersionMigrationRollingBack',
]);

export function migrationStatusWithActiveMigrationGate(
  statusTypename: string | undefined
): boolean {
  return Boolean(
    statusTypename &&
      MIGRATION_GRAPHQL_STATUSES_INDICATING_ACTIVE_GATE.has(statusTypename)
  );
}

export const hasMigrationWindowExpired = (
  migrationStartedAt: string | null
) => {
  /**
   * After a migration is completed, users have a window of time to view
   * the migration flow. After this window has expired, they will be taken
   * straight to the app.
   * Note: startedAt is also removed from Redis after 30 days
   */
  if (migrationStartedAt === null) return true;

  const daysSinceMigration = Math.max(
    differenceInDays(new Date(migrationStartedAt), new Date()),
    0
  );

  return daysSinceMigration > MIGRATION_DAY_WINDOW;
};
